import { IconInfoLight } from 'components/icons/IconInfoLight'

// If the icon or styling here changes, also update the TitleHelpIconTooltip component
export const TitleHelpIconButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div
      css={{
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <IconInfoLight />
    </div>
  )
}
